
import Dexie from 'dexie'
import { useLiveQuery } from "dexie-react-hooks";
// import { log } from "../services/Utils";

//DATABASE OFFLINE
const getDb = () => {
    var db = new Dexie('EBMS');
    db.version(7).stores(
        {
            surveys: "++id,survey_id,token,name,location,country,questionnaire,description,startdate,enddate,project_id,status,version,live_status,created_at,updated_at",
            submissions: "++id,sync_token,token,survey_responses,ip_address,location,version,started_at,ended_at,user_id,sync_status",
            user:"++id,user_id,details"

        }
    )
    db.open().catch(function (e) {
        console.error("Open failed: " + e.stack);
    })
    return db;
    // return new Dexie('EBMS');
};
// const initializeSchema = () => {
//     getDb().version(1).stores(
//         { surveys: "++id,survey_id,token,name,location,country,questionnaire,description,startdate,enddate,project_id,status,version,live_status,created_at,updated_at" }
//     )
//     log("SCHEMA: ", " Schema initialized successfully");
// };
// const getOfflineData = (SCHEMA, options) => {
//     const allItems = useLiveQuery(() => getDb().surveys.toArray(), []);
//     if (!allItems)
//         return null;
//     return allItems;
// }
const GetAllSurveys = () => {
    let dba = getDb();
    const allSurveys = useLiveQuery(
        () => dba.surveys
            // .where('age')
            // .above(75)
            .toArray()
    );

    if (!allSurveys) return []; // Still loading.
    return allSurveys;
}
export {
    getDb,
    GetAllSurveys
    // initializeSchema,

};